import { addMinutes } from 'date-fns';
import { useEffect } from 'react';
import { getSSOMetadata } from '../../utils/auth';
import { useNotificationDispatch } from '../notifications/NotificationProvider';
import { signOutUser } from '../../sources/authentication';

const idleTimeoutKey = 'boomi_flow_sso_idle_timeout';

const IdleTimeout = () => {
    const dispatchNotification = useNotificationDispatch();

    useEffect(() => {
        const ssoMetadata = getSSOMetadata();
        if (!(ssoMetadata?.idleTimeout && ssoMetadata?.idleTimeout > 0)) {
            localStorage.removeItem(idleTimeoutKey);
            return;
        }
        const updateTimeout = () =>
            localStorage.setItem(
                idleTimeoutKey,
                addMinutes(new Date(), ssoMetadata.idleTimeout as number).toISOString(),
            );
        window.addEventListener('click', updateTimeout);
        window.addEventListener('keyup', updateTimeout);
        updateTimeout();
        const interval = setInterval(() => {
            const storedIdleTimeout = localStorage.getItem(idleTimeoutKey);

            if (storedIdleTimeout && Date.now() > new Date(storedIdleTimeout).getTime()) {
                clearInterval(interval);
                localStorage.removeItem(idleTimeoutKey);
                signOutUser(true);
            }

            if (storedIdleTimeout) {
                const storedTimeoutDate = Date.parse(storedIdleTimeout);
                const roundedMinutesLeft = Math.round((storedTimeoutDate - Date.now()) / 1000 / 60);
                // Don't display a warning at less than a minute as it looks buggy
                if (roundedMinutesLeft < 6 && roundedMinutesLeft !== 0) {
                    dispatchNotification({
                        type: 'addNotification',
                        payload: {
                            type: 'warning',
                            message: `You will be signed out due to inactivity in ${roundedMinutesLeft} minute(s) at ${new Date(
                                storedIdleTimeout,
                            ).toLocaleString()}.`,
                            isPersistent: true,
                        },
                    });
                }
            }
        }, 60000); //every minute

        return () => {
            if (interval) {
                clearInterval(interval);
            }
            localStorage.removeItem(idleTimeoutKey);
            window.removeEventListener('click', updateTimeout);
            window.removeEventListener('keyup', updateTimeout);
        };
    }, [dispatchNotification]);
    return null;
};

export default IdleTimeout;
